import { auth } from '@link/admin/stores';
import ShareAuth from '@link/share/vendors/firebase';

const adminAuth = new ShareAuth(auth);

export const storage = adminAuth.storage;
export default adminAuth;
